// AISuggestionsPanel.jsx
import React, { useState } from "react";

const STATUS_LABEL = { pending: "Pending", accepted: "Accepted", rejected: "Rejected" };

function formatValue(v) {
  if (v == null) return "—";
  if (typeof v === "string") return v;
  try { return JSON.stringify(v, null, 2); } catch { return String(v); }
}

export default function AISuggestionsPanel({
  workId,
  suggestions = [],
  onDecided,
  apiBase = "/api/admin/choral",
}) {
  const [busyId, setBusyId] = useState(null);
  const [error, setError] = useState(null);

  async function decide(suggestionId, action) {
    const reason = window.prompt(`Reason to ${action}:`);
    if (!reason && action === "reject") return;
    setBusyId(suggestionId);
    setError(null);
    try {
      const res = await fetch(`${apiBase}/${workId}/suggestions/decision`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ suggestion_id: suggestionId, action, reason }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({ detail: `HTTP ${res.status}` }));
        throw new Error(err.detail || `HTTP ${res.status}`);
      }
      onDecided?.(await res.json());
    } catch (e) {
      setError(e.message);
    } finally {
      setBusyId(null);
    }
  }

  return (
    <section className="ce-suggestions" data-testid="ce-suggestions-panel">
      <h2>AI Editorial Suggestions</h2>
      {suggestions.length === 0 ? (
        <p style={{ color: "var(--li-text-secondary, #5C5450)", fontStyle: "italic" }}>
          No pending AI suggestions for this work.
        </p>
      ) : (
        suggestions.map((s) => (
          <article
            key={s.id}
            className="ce-suggestion"
            data-testid={`ce-suggestion-${s.id}`}
          >
            <div className="ce-suggestion__body">
              <p className="ce-suggestion__field">{s.field}</p>
              <div className="ce-suggestion__value">{formatValue(s.suggested_value)}</div>
              {s.rationale && (
                <p className="ce-suggestion__rationale">"{s.rationale}"</p>
              )}
            </div>
            <div className="ce-suggestion__actions">
              {s.status === "pending" ? (
                <>
                  <button
                    className="ce-primary"
                    disabled={busyId === s.id}
                    onClick={() => decide(s.id, "accept")}
                    data-testid={`ce-suggestion-accept-${s.id}`}
                  >
                    Accept
                  </button>
                  <button
                    className="ce-secondary"
                    disabled={busyId === s.id}
                    onClick={() => decide(s.id, "reject")}
                    data-testid={`ce-suggestion-reject-${s.id}`}
                  >
                    Reject
                  </button>
                </>
              ) : (
                <span className="ce-suggestion__status">{STATUS_LABEL[s.status] || s.status}</span>
              )}
            </div>
          </article>
        ))
      )}
      {error && (
        <p style={{ marginTop: 10, color: "#8A5A32" }}>{error}</p>
      )}
    </section>
  );
}
